import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  NgZone,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { AnalyticsService } from '../../services/analytics.service';
import { coerceBooleanProperty } from '@angular/cdk/coercion';

let uid = 0;

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'app-radio',
  templateUrl: './app-radio.component.html',
  styleUrls: ['./app-radio.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppRadioComponent {
  private _id = `app-radio-${uid++}`;
  private _checked = false;
  @Input() radioGAData!: any;
  @Input() id = this._id;
  @Input({ required: true }) name!: string;
  @Input() value: any;
  @Input()
  set checked(v: any) {
    this._checked = coerceBooleanProperty(v);
  }
  get checked() {
    return this._checked;
  }
  @Input() disabled = false;
  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() change = new EventEmitter<any>();

  constructor(
    private analyticsService: AnalyticsService,
    private cd: ChangeDetectorRef
  ) {}

  reset() {
    this._checked = false;
    this.cd.markForCheck();
  }

  onChange(ev: Event) {
    if (this.disabled) return;
    const input = ev.target as HTMLInputElement;
    this._checked = input.checked;
    this.cd.markForCheck();
    this.change.emit(this.value);
  }
}
